import { render, staticRenderFns } from "./AddDiagnosisDet.vue?vue&type=template&id=1e5420c2"
import script from "./AddDiagnosisDet.vue?vue&type=script&lang=js"
export * from "./AddDiagnosisDet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports